<div class="row">
  <div class="col-md-12 col-xs-12 col-sm-12">
    <div class="header_txt_white">
      <!-- <h2 *ngIf="!!header"> {{header}}</h2> -->
      <h2 *ngIf="!!header">{{header | translate}}</h2>
    </div>
  </div>
</div>
